import axios from "axios";

const rsvURL = "/api/v1/reference_sources";

const referenceSourceValuesOverviewURL = "/api/v1/reference_source_values";

const referenceSourceValuesApi = {
  index: (id, searchTerm = "", currentPage = 1, pageSize = 10) =>
    axios.get(
      `${rsvURL}/${id}/reference_source_values?search=${searchTerm}&page=${currentPage}&per_page=${pageSize}`
    ),
  create: (payload, id) =>
    axios.post(`${rsvURL}/${id}/reference_source_values`, {
      reference_source_value: payload,
    }),
  show: (id, rsv_id) =>
    axios.get(`${rsvURL}/${id}/reference_source_values/${rsv_id}`),
  upload: payload =>
    axios.post(referenceSourceValuesOverviewURL, {
      reference_source_value: payload,
    }),
  associate: (id, payload) =>
    axios.post(`${rsvURL}/${id}/reference_source_values/associate`, {
      reference_source_value: payload,
    }),
  destroy_by_ids: payload =>
    axios.post(`${referenceSourceValuesOverviewURL}/destroy_by_ids`, {
      reference_source_value: payload,
    }),
  update: (id, payload) =>
    axios.put(`${referenceSourceValuesOverviewURL}/${id}`, {
      reference_source_value: payload,
    }),
};

export default referenceSourceValuesApi;
